import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import NavbarHook from "./Components/NavbarHook/NavbarHook";
import Home from "./pages/Home";
import Aboutus from "./pages/Aboutus";
import InMemoriam from "./pages/Memoriam";
import Footer from "./Components/Footer/Footer";
import FosterHome from "./pages/FosterHome";
import Donate from "./pages/Donate";
import DonateToUs from "./pages/DonateToUs";
import Volunteer from "./pages/Volunteer";
import Contact from "./pages/Contact";
import AdoptableDog from "./pages/AdoptableDog";
import HappyStories from "./pages/HappyStories";
import Title from "./Components/Title";
import { useTranslation } from "react-i18next";

/** Selects image and translation key based on route path */
const getCurrentImagePath = (pathname) => {
  switch (pathname) {
    case "/about-us":
      return { imagePath: "../img/title/about-us.jpg", titleKey: "about.title" };
    case "/adopt":
      return { imagePath: "../img/title/adopt.jpg", titleKey: "adopt.title" };
    case "/happy-stories":
      return { imagePath: "../img/title/happy-stories.jpg", titleKey: "happy-stories.title" };
    case "/in-memoriam":
      return { imagePath: "../img/title/memoriam.jpg", titleKey: "memoriam.title" };
    case "/become-a-foster-home":
      return { imagePath: "../img/title/foster.jpg", titleKey: "foster.title" };
    case "/volunteer":
      return { imagePath: "../img/title/volunteer.jpg", titleKey: "volunteer.title" };
    case "/donating-items-to-us":
      return { imagePath: "../img/title/donate-to-us.jpg", titleKey: "donate-to-us.title" };
    case "/contact":
      return { imagePath: "../img/title/contact.jpg", titleKey: "contact.title" };
    case "/donate":
      return { imagePath: "../img/title/donate.jpg", titleKey: "donate.title" };
    default:
      return { imagePath: "../img/title/home.jpg", titleKey: "home.title" };
  }
};

/** Displays Title dynamically per route */
const TitleWithLocation = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { imagePath, titleKey } = getCurrentImagePath(location.pathname);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  return (
    <div
      style={{
        width: "100vw",
        marginTop: "4rem",
        marginLeft: "calc(-50vw + 50%)", 
        overflow: "hidden",
      }}
    >
      <Title title={t(titleKey)} imagePath={imagePath} />
    </div>
  );
};


/** Main App component */
const App = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Adjust padding, but don’t alter hero images
  const mainStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    width: "100%",
  };

  const contentStyle = {
    flex: 1,
    padding:
      windowWidth < 600
        ? "0.8rem"
        : windowWidth < 900
          ? "1rem 1.5rem"
          : "1.5rem 3rem",
    boxSizing: "border-box",
  };

  return (
    <Router>
      <div style={mainStyle}>
        <NavbarHook />
        <main style={contentStyle}>
          <TitleWithLocation />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<Aboutus />} />
            <Route path="/adopt" element={<AdoptableDog />} />
            <Route path="/happy-stories" element={<HappyStories />} />
            <Route path="/in-memoriam" element={<InMemoriam />} />
            <Route path="/become-a-foster-home" element={<FosterHome />} />
            <Route path="/volunteer" element={<Volunteer />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/donating-items-to-us" element={<DonateToUs />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
